import App from '@/models/App'

export default class ShipLaborWork extends App {
    static get entity() {
        return 'ShipLaborWorks'
    }
    static all() {
        return this.query().withAllRecursive().where('isDeleted', false).get()
    }
    static fetch() {
        return this.query()
            .withAllRecursive()
            .get()
            .filter((value) => {
                return value.isDeleted === false && value.isRest === false
            })
    }
    static allHistory() {
        return this.query().withAllRecursive().get()
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static findByFirst() {
        return this.query().withAllRecursive().first()
    }
    static findByRest() {
        // こいつで休憩が特定できなくなった
        // isRestがtrueのやつは: 休憩、安全臨時労働、緊急作業の3つ
        return this.query().withAllRecursive().where('isRest', true).first()
    }
    static isWorkTime(id) {
        return !this.query().whereId(id).first().isLock
    }
    static fetchByWorkIds() {
        return this.query()
            .withAllRecursive()
            .where('isLock', false)
            .get()
            .map(function (row) {
                return row.id
            })
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            name: this.attr(''),
            background: this.attr(''),
            isLock: this.attr(true),
            isRest: this.attr(true),
            isWork: this.attr(true),
            isDeleted: this.attr(false),
            isDefault: this.attr(true),
            sortNum: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId) {
                return this.get(`${shipId}/labors/works`, {
                    params: { all: true },
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            save(shipId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(
                    `${shipId}/labors/works/saved`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
